import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ContratoEdicao } from '@/features/contrato/page/edicao/ContratoEdicao';
import { StringToIdpkSchema } from '@/std/schema';

const RouteContratoParamsSchema = z.discriminatedUnion('action', [
    z.object({
        action: z.literal('cadastrar'),
        idpk: z.undefined().optional(),
    }),
    z.object({
        action: z.enum(['editar', 'visualizar']),
        idpk: StringToIdpkSchema,
    }),
]);

export type RouteContratoParams = z.infer<typeof RouteContratoParamsSchema>;

export const Route = createFileRoute('/a/contrato/$action/{-$idpk}')({
    component: Component,
    params: {
        parse: (params) => {
            const result = RouteContratoParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
});

function Component() {
    const params = Route.useParams();

    return <ContratoEdicao {...params} />;
}
